/** Rol administrador del sistema (acceso total) */
export const isAdmin = (role?: string | null) => role === 'admin';

/** Rol profesor con permisos limitados a sus programas asignados */
export const isRestrictedTeacher = (role?: string | null) => role === 'teacher';

export const isTeacherAdmin = (role?: string | null) => role === 'teacher_admin';

/** Acceso de administrador en gestión académica (admin o profesor admin) */
export const hasAcademyAdminAccess = (role?: string | null) =>
  role === 'admin' || role === 'teacher_admin';

export const resolveTeacherAdminBranchFromCity = (city?: string | null) => {
  const normalized = city?.trim().toLowerCase();
  if (!normalized) return null;
  if (normalized === 'barranquilla' || normalized.startsWith('barranquilla')) {
    return 'BARRANQUILLA';
  }
  if (normalized === 'sincelejo' || normalized.startsWith('sincelejo')) {
    return 'SINCELEJO';
  }
  return null;
};

export const isAcademyBranchCity = (city?: string | null) =>
  Boolean(resolveTeacherAdminBranchFromCity(city));

export type SidebarMenuKey = 'admin' | 'seller' | 'teacher' | 'teacher_admin';

export const resolveSidebarMenuKey = (
  role?: string | null
): SidebarMenuKey | null => {
  if (!role) return null;
  if (role === 'admin') return 'admin';
  if (role === 'seller') return 'seller';
  if (role === 'teacher') return 'teacher';
  if (role === 'teacher_admin') return 'teacher_admin';
  return null;
};

export const readStoredUserRole = (): string | null => {
  if (typeof localStorage === 'undefined') return null;

  try {
    const storedUser = localStorage.getItem('user');
    if (!storedUser) return null;
    return JSON.parse(storedUser)?.role ?? null;
  } catch {
    return null;
  }
};
